"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Idea = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Idea = function Idea(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.796.321a5.68 5.68 0 012.871 10.696l-.004.994a.68.68 0 01-.683.677l-4-.017a.68.68 0 01-.677-.683l.004-.994A5.68 5.68 0 017.796.32zm2.285 1.886a4.32 4.32 0 10-3.817 7.742.68.68 0 01.405.625l-.003.74 2.64.012.003-.74a.68.68 0 01.41-.622 4.32 4.32 0 00.362-7.757zM8.324 3.393a.68.68 0 01.3.914L8.112 5.32l.9.003a.68.68 0 01.603.987L8.607 8.307a.68.68 0 11-1.214-.614l.512-1.013-.9-.004a.68.68 0 01-.603-.987L7.41 3.693a.68.68 0 01.914-.3zM5.294 13.99a.68.68 0 01.683-.678l4 .018a.68.68 0 01-.005 1.36l-4-.018a.68.68 0 01-.677-.682z",
    fill: "currentColor"
  }));
};

exports.Idea = Idea;
var _default = Idea;
exports.default = _default;